// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:52:37

export default {
  "id": "jumping-fish-ragdoll-3d",
  "slug": "jumping-fish-ragdoll-3d",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/31af60b13056474ebcd85b7a46c9e01b-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/31af60b13056474ebcd85b7a46c9e01b/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Jumping Fish: Ragdoll 3D",
      "description": "Experience a fun and challenging ragdoll adventure where you control a jumping fish! Time your jumps, adjust power, and navigate through tricky levels. Reach checkpoints to unlock new areas filled with obstacles and surprises. Can you master the perfect jump and complete all levels?",
      "instructions": "LMB Up/Down – Adjust Jump Power (Hold, Adjust, Release)\nRMB – Control Camera Direction",
      "genres": [
        "Adventure",
        "Agility"
      ],
      "tags": [
        "arcade",
        "fish",
        "jumping",
        "platformer",
        "ragdoll"
      ]
    },
    "zh-CN": {
      "title": "跳跃鱼：布娃娃3D",
      "description": "体验一场有趣且充满挑战的拉格doll冒险，你将操控一只跳动的鱼！计时跳跃，调整力度，通过棘手的关卡。达到检查点解锁充满障碍和惊喜的新区域。你能掌握完美的跳跃并完成所有关卡吗？",
      "instructions": "左鼠标按钮（LMB）上下滑动 - 调整跳跃力量（按住，调整，释放）\n右鼠标按钮（RMB） - 控制摄像头方向",
      "genres": [
        "冒险",
        "敏捷"
      ],
      "tags": [
        "街机",
        "鱼",
        "跳跃",
        "平台",
        "布娃娃"
      ]
    },
    "zh-TW": {
      "title": "跳躍魚：拉格鐙3D",
      "description": "體驗一場有趣且挑戰性的拉洋片冒險，操控一條跳躍的魚！調整跳躍時間，調整力量，並穿梭於複雜的關卡。通過檢查點以解鎖充滿障礙和驚喜的新區域。你能掌握完美的跳躍並完成所有關卡嗎？",
      "instructions": "左鍵按鈕上/下 – 調整跳躍力量（按住，調整，放開）\n右鍵按鈕 – 控制相機方向",
      "genres": [
        "冒險",
        "敏捷性"
      ],
      "tags": [
        "電玩",
        "魚",
        "跳躍",
        "平台遊戲",
        "拉鍊人偶"
      ]
    },
    "zh-HK": {
      "title": "跳躍魚：拉鍊3D",
      "description": "體驗一場有趣而挑戰性的拉洋娃娃冒險，操控一條跳躍的魚！計時跳躍，調整力量，穿梭於複雜關卡。通過檢查點來解鎖充滿障礙和驚喜的新區域。你能掌握完美的跳躍，完成所有關卡嗎？",
      "instructions": "LMB 上/下 – 調節跳躍力量（按住，調整，放開）\nRMB – 控制相機方向",
      "genres": [
        "冒險",
        "靈敏度"
      ],
      "tags": [
        "街機",
        "魚",
        "跳躍",
        "平台遊戲",
        "ragdoll"
      ]
    },
    "ja": {
      "title": "ジャンプングフィッシュ: ラグドール3D",
      "description": "楽しい挑戦的なラグドール冒険を体験して、ジャンプする魚を操りましょう！ジャンプのタイミングを調整し、力を調節して、難しいレベルを進んでください。チェックポイントに到達して、障害と驚きに満ちた新しいエリアを解禁しましょう。完璧なジャンプをマスターして、すべてのレベルをクリアできるでしょうか？",
      "instructions": "LMB 上/下 - ジャンプの力を調整（ホールド、調整、リリース）\nRMB - カメラの方向を制御",
      "genres": [
        "アドベンチャー",
        "アギリティ"
      ],
      "tags": [
        "アーケード",
        "魚",
        "ジャンプ",
        "プラットフォーム",
        "ラグドール"
      ]
    },
    "ko": {
      "title": "점프하는 물고기: 러그도ール 3D",
      "description": "캐릭터를 제어하는 점프하는 물고기와 함께 즐거운 도전적인 ragdoll 모험을 경험해보세요! 점프 시간을 맞추고, 힘을 조절하여 복잡한 레벨을 돌아다니세요. 체크포인트에 도달하여 장애물과 놀라운 예측치가 가득한 새로운 구역을 해금하세요. 완벽한 점프를 마스터하고 모든 레벨을 완료할 수 있을까요?",
      "instructions": "LMB 상/하 – 점프 파워 조정 (위持, 조정, 방출)\nRMB – 카메라 방향 제어",
      "genres": [
        "모험",
        "유연성"
      ],
      "tags": [
        "어케이드",
        "물고기",
        "점프",
        "플랫폼",
        "레그돌"
      ]
    },
    "fr": {
      "title": "Poisson Saltant : Ragdoll 3D",
      "description": "Expérimentez une aventure rigolante et challengeante où vous contrôlez un poisson sautant ! Temperez vos sauts, ajustez la puissance et naviguez à travers des niveaux délicats. Arrivez aux points de contrôle pour déverrouiller de nouvelles zones remplies d'obstacles et de surprises. Pouvez-vous maîtriser le saut parfait et terminer tous les niveaux ?",
      "instructions": "LMB Haut/Bas – Ajuster la Puissance du Saut (Maintenir, Ajuster, Relâcher)\nRMB – Contrôler la Direction de la Caméra",
      "genres": [
        "Aventure",
        "Agilité"
      ],
      "tags": [
        "arcade",
        "poisson",
        "saut",
        "plateformer",
        "ragdoll"
      ]
    }
  }
};
